import {
    faGaugeHigh,
    faBook,
    faTruck,
    faSyncAlt,
    faChartLine,
    faBookOpen,
    faMoneyBillWaveAlt,
    faStore,
    faUsers,
    faBookBookmark, faNewspaper,
    faShareNodes,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Single source of truth for the admin navigation.
 *
 * `APP_NAV` is the render tree: a flat list where every entry is either a
 * module or a group (`type: 'group'`) whose `children` are modules. Groups are
 * shown in the sidebar as an expandable submenu that reuses the same item
 * design; the group is only visible when at least one child is visible.
 *
 * Every module maps one route, its icon and the title/subtitle shown in the
 * sidebar. `permission` (optional) is a [module, action] pair evaluated with
 * usePermissions(); entries without it are always visible. `match` (optional)
 * lists extra paths that should keep the item highlighted (e.g. Financieros
 * lives inside the Ventas module).
 *
 * `APP_MODULES` is the flattened list of every module (groups excluded); it is
 * kept as the single source of truth for anything that needs the flat list.
 *
 * Financieros is intentionally NOT a top-level module: it is reached from a
 * button inside Ventas.
 */
export const APP_NAV = [
    {
        key: 'dashboard',
        path: '/dashboard',
        icon: faGaugeHigh,
        title: 'Dashboard',
        subtitle: 'Estadísticas generales.',
    },
    {
        key: 'distribution',
        type: 'group',
        icon: faShareNodes,
        title: 'Distribución',
        subtitle: 'Catálogo, reportes, canales y delivery.',
        children: [
            {
                key: 'stock',
                path: '/stock',
                icon: faBook,
                title: 'Catálogo',
                subtitle: 'Inventario y metadatos de tus libros.',
            },
            {
                key: 'reports',
                path: '/reports',
                icon: faChartLine,
                title: 'Reportes',
                subtitle: 'Estado del catálogo en tiendas.',
            },
            {
                key: 'channels',
                path: '/channels',
                icon: faStore,
                title: 'Canales',
                subtitle: 'Canales de distribución y configuraciones.',
                permission: ['distribution', 'view'],
            },
            {
                key: 'delivery',
                path: '/delivery',
                icon: faTruck,
                title: 'Delivery',
                subtitle: 'Envío y estado en las tiendas.',
            },
        ],
    },
    {
        key: 'conversions',
        path: '/conversions',
        icon: faSyncAlt,
        title: 'Conversiones',
        subtitle: 'Procesos de conversión y archivos.',
    },
    {
        key: 'ingram',
        path: '/ingram',
        icon: faBookOpen,
        title: 'Ingram',
        subtitle: 'Catálogo de Ingram.',
    },
    {
        key: 'payments',
        path: '/payments',
        icon: faMoneyBillWaveAlt,
        title: 'Ventas',
        subtitle: 'Consulta ventas y finanzas por periodo.',
        match: ['/financial'],
    },
    {
        key: 'accounts-users',
        path: '/accounts-users',
        icon: faUsers,
        title: 'Cuentas y Usuarios',
        subtitle: 'Cuentas, usuarios, servicios y roles.',
        permission: ['users', 'view'],
    },
    {
        key: 'biblio',
        path: '/biblio',
        icon: faBookBookmark,
        title: 'Biblio',
        subtitle: 'Tiendas, planes y reportes de Biblioteca.',
        permission: ['biblio', 'manage_plans'],
        internalOnly: true,
    },
    {
        key: 'newsletter',
        path: '/newsletter',
        icon: faNewspaper,
        title: 'Newsletter',
        subtitle: 'Novedades a canales',
        permission: ['distribution', 'view'],
    },
];

/**
 * Flat list of every module. Groups are expanded into their children so a
 * consumer can look up a module by key/path without walking the tree.
 */
export const APP_MODULES = APP_NAV.flatMap((entry) => (
    entry.type === 'group' ? entry.children : [entry]
));

export default APP_NAV;
